/* eslint-disable no-undef */
<template>
  <v-container>
    <v-dialog v-model="dialog" max-width="400px" persistent>
      <v-card :loading="loading" class="mx-auto">
        <v-card-title>
          <span class="headline">SOLICITAR AGENTE</span>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" text @click="cerrarModal">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="text--primary px-8">
          <ValidationObserver ref="form">
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <ValidationProvider name="Tipo Usuario" rules="required">
                  <v-autocomplete
                    v-model="tipo"
                    :items="tipoUsuario"
                    label="Tipo Usuario"
                    slot-scope="{ errors, valid }"
                    :error-messages="errors"
                    :success="valid"
                  ></v-autocomplete>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>

        <v-card-actions class="pb-8 pl-8">
          <v-btn @click="save" color="primary" dark :loading="loading">
            Solicitar
          </v-btn>
          <v-btn color="warning" dark @click="cerrarModal"> Cancelar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { db } from "../../firebase";
export default {
  name: "ModAddSolicitar",
  data: () => ({
    loading: false,
    dialog: true,
    tipoUsuario: [],
    tipo: "",
    estadoUsuarioLogueado: "",
    campo: "",
    datosCaso: "",
    crearChat: {},
    roles: [],
    planesAutorizados: ["SEGURO TERCERO", "RC PUBLICO", "RC Publico"],
  }),
  async created() {
    this.campo =
      this.logueado.cargo === "Abogado" ? "uidabogado" : "uidinvestigador";
    db.collection("casos")
      .where(this.campo, "==", this.logueado.id)
      .where("archivado", "==", false)
      .get()
      .then((res) => {
        this.estadoUsuarioLogueado =
          res.size > 1 ? "Activo multiple" : "Activo ocupado";
      });
    if (this.logueado.cargo === "Administrador")
      this.tipoUsuario = [
        "Abogado",
        "Abogado CAIT",
        "Investigador",
        "Perito",
        "Dibujante",
      ];
    if (
      this.logueado.cargo === "Coordinador Contact Center" ||
      this.logueado.cargo === "Call Center"
    )
      this.tipoUsuario = [
        "Abogado",
        "Abogado CAIT",
        "Investigador",
        "Dibujante",
      ];
    if (
      this.logueado.cargo === "Coordinador Investigador" ||
      this.logueado.cargo === "Investigador"
    )
      this.tipoUsuario = ["Perito", "Dibujante"];
  },
  props: {
    id: { type: String, default: "" },
    tipoPlanCaso: { type: String, default: "" },
    showModal: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(["logueado"]),
  },
  async mounted() {
    try {
      const datos = await db.collection("casos").doc(this.id).get();
      this.datosCaso = datos.data();
    } catch (error) {
      console.log(error);
    }
  },
  methods: {
    ...mapActions("notification", ["EnviarNotificaciones"]),
    async save() {
      this.loading = true;
      console.log("solicitando agente");
      const validar = await this.$refs.form.validate();
      if (!validar) return false;
      const parametro = {
        modificacion: Date.now(),
      };
      if (this.tipo == "Perito") {
        if (!this.planesAutorizados.includes(this.tipoPlanCaso)) {
          this.$swal({
            icon: "warning",
            title: "Operación denegada",
            text: "El plan adquirido no cuenta con este servicio",
          });
          return;
        }
        // TODO: CREACIÓN DEL CHAT DE PERITOS
        this.crearChatPeritoDibujante(
          "chatsperito",
          this.datosCaso.solicitud_perito
        );
        parametro.solicitud_perito = true;
        parametro.chat_perito = true;
      } else if (this.tipo == "Investigador") {
        parametro.solicitud_investigador = true;
      } else if (this.tipo == "Dibujante") {
        // TODO: CREACIÓN DEL CHAT DE Dibujante
        this.crearChatPeritoDibujante(
          "chatsdibujante",
          this.datosCaso.solicitud_dibujante
        );
        parametro.solicitud_dibujante = true;
        parametro.uiddibujante = "solicitado";
      }
      await db.collection("casos").doc(this.id).update(parametro);
      // se guarda la trazabilidad del caso
      this.$store.dispatch("trazabilidadCaso", {
        descripcion: `El ${this.logueado.cargo} ha solicitado un ${this.tipo} al caso`,
        uidcaso: this.id,
        uidcreador: this.logueado.id,
      });
      // TODO: ENVIAR NOTIFICACIONES
      this.roles = ["Administrador", `Coordinador ${this.tipo}`];
      this.envioNotificacion();
      this.$swal({ icon: "success", title: "Operación Exitosa", text: "" });
      this.loading = false;
      this.cerrarModal();
      this.$emit("actualizar");
    },
    async envioNotificacion() {
      // Consultar tokens de los coordinadores de contact center para enviar notificaciones
      const usuarios = await db
        .collection("usuarios")
        .where("cargo", "in", this.roles)
        .get();

      const objUsuNotificar = usuarios.docs.map((e) => ({
        ...e.data(),
      }));

      const usu = objUsuNotificar
        .filter((e) => {
          return e.tokenPush;
        })
        .map((u) => {
          return u.tokenPush;
        });

      this.registration_ids = [...usu];
      this.EnviarNotificaciones({
        registration_ids: this.registration_ids,
        title: "Solicitud",
        message: `El ${this.logueado.cargo} ha solicitado un ${this.tipo} al caso #${this.datosCaso.caso}`,
      });
    },
    async crearChatPeritoDibujante(coleccion, solicitud) {
      try {
        //this.datosCaso.solicitud_perito
        if (solicitud) return;
        console.log("crear chat");
        // eslint-disable-next-line
        this.crearChat.avatar = "https://firebasestorage.googleapis.com/v0/b/servdigipats.appspot.com/o/foto-perfil%2Fvml.ico?alt=media&token=d93de8fc-dc76-4c53-bb6e-f8420d814827";
        this.crearChat.roomName = "Chat en proceso (Entrar)";
        this.crearChat.uidcaso = this.id;
        this.crearChat.unreadCoun = 0;
        this.crearChat.users = [];
        console.log(this.crearChat, "chat");
        const resChat = await db.collection(coleccion).add(this.crearChat);
        await db
          .collection(coleccion)
          .doc(resChat.id)
          .update({ roomId: resChat.id });
      } catch (error) {
        console.log(error);
      }
    },
    cerrarModal() {
      this.$emit("update:showModal", !this.showModal);
    },
    handleError({ message }) {
      this.$swal({ icon: "error", title: "Oops...", text: message });
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.div-opciones
    overflow: auto
    height: 240px
</style>
